/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect} from 'react'
import {Column} from 'react-table'
import {KTCard} from '../../../../../../../../_metronic/helpers'
import {KTable, KTableHeader, KTableLoading} from '../../../../../../components/UI'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import {AvailabilityModel} from '../../../../models/availability.model'

const TableAvailability: FC = () => {
  const {data, loading, setLoading, pagination} = useKTable()
  const {currentTabItem} = useHoteleria()
  //   const getModules = async () => {
  //     try {
  //       setLoading(true)
  //       changeSearchValues({})
  //       const {data: response} = await getModulesService({
  //         pageNumber: pagination.currentPage,
  //         size: pagination.perPage,
  //       })
  //       if (!response.error) {
  //         setData(response.data)
  //         setPagination({
  //           ...pagination,
  //           totalResults: response.total,
  //         })
  //       }
  //       setLoading(false)
  //     } catch (error) {
  //       setLoading(false)
  //     }
  //   }

  useEffect(() => {
    // getModules()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  useEffect(() => {
    if (currentTabItem.deleted) {
      //   clearSelected()
      //   getModules()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.deleted])

  useEffect(() => {
    if (currentTabItem.updated) {
      //   clearSelected()
      //   getModules()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.updated])

  const columns: Column<AvailabilityModel>[] = [
    {
      Header: (props) => <KTableHeader tableProps={props} title='Tipo de Módulo' />,
      accessor: 'TipoModulo_descripcion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Módulo' />,
      accessor: 'Modulo_descripcion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Sexo Módulo' />,
      accessor: 'ModuloSexo_descripcion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Nro de Pisos' />,
      accessor: 'NroPisosModulo',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Tipo de Baño' />,
      accessor: 'ModuloTipoBanio_descripcion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Estado de Módulo' />,
      accessor: 'EstadoModulo_descripcion',
    },

    {
      Header: (props) => <KTableHeader tableProps={props} title='Tipo de Habitación' />,
      accessor: 'TipoHabitacion_descripcion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Habitación' />,
      accessor: 'Habitacion_descripcion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Sexo Habitación' />,
      accessor: 'HabitacionSexo_descripcion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Piso Habitación' />,
      accessor: 'HabitacionNivel_descripcion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Tipo de Baño' />,
      accessor: 'HabitacionTipoBanio_descripcion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Estado de Habitación' />,
      accessor: 'EstadoHabitacion_descripcion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Sub Estado de Habitación' />,
      accessor: 'SubEstadoHabitacion_descripcion',
    },

    {
      Header: (props) => <KTableHeader tableProps={props} title='Tipo de Cama' />,
      accessor: 'TipoCama_descripcion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Cama' />,
      accessor: 'Cama_descripcion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Cama Caliente' />,
      accessor: 'CamaCaliente',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Estado de Cama' />,
      accessor: 'EstadoCama_descripcion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Sub Estado de Cama' />,
      accessor: 'SubEstadoCama_descripcion',
    },
  ]

  useEffect(() => {
    setLoading(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  return (
    <>
      <KTCard shadow className='m-5'>
        <KTable data={data} columns={columns} />
        {loading ? <KTableLoading title='Cargando...' /> : null}
      </KTCard>
    </>
  )
}

const TableAvailabilityWrapper = () => {
  return (
    <KTableProvider>
      <TableAvailability />
    </KTableProvider>
  )
}

export {TableAvailabilityWrapper}
